import ReactDOM from 'react-dom'
import React from 'react'
import {PaymentComponent} from './PaymentComponent'
import {NanoId} from '../../server/model/Ids'

const textIdJson = document.getElementById('text-json')!
const text = JSON.parse(textIdJson.innerText)
const paypalClientId = document.getElementById('paypalClientId')!.innerText

ReactDOM.render(
    <PaymentComponent textId={text.id} paypalClientId={paypalClientId}/>,
    document.querySelector('#payment-app-root'))